"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterType = exports.getDateFromCacheReadOptions = exports.isTruthy = void 0;
exports.isNonEmptyObject = isNonEmptyObject;
exports.isExactlyOneDefined = isExactlyOneDefined;
const assert_1 = __importDefault(require("assert"));
const moment_1 = __importDefault(require("moment"));
/**
 * **Type guard** – returns true only when the object has at least
 * one own enumerable key, and narrows away `EmptyObject`.
 */
function isNonEmptyObject(value) {
    // value is already known to be an object in the union you described,
    // so only the key-count test is needed
    return Object.keys(value).length > 0;
}
const isTruthy = (value) => Boolean(value);
exports.isTruthy = isTruthy;
/**
 * This function returns a Date object based on the given cache read option, or undefined if the cache should not be read.
 * @param cacheReadOption
 * @returns
 */
const getDateFromCacheReadOptions = (cacheReadOption) => {
    if ('createdAfter' in cacheReadOption) {
        (0, assert_1.default)(cacheReadOption.createdAfter, 'createdAfter must be defined');
        return cacheReadOption.createdAfter;
    }
    if ('withInDays' in cacheReadOption) {
        (0, assert_1.default)(cacheReadOption.withInDays, 'withInDays must be defined');
        return (0, moment_1.default)().subtract(cacheReadOption.withInDays, 'days').toDate();
    }
    (0, assert_1.default)(cacheReadOption.noCacheRead, 'noCacheRead must be true');
    return undefined;
};
exports.getDateFromCacheReadOptions = getDateFromCacheReadOptions;
var FilterType;
(function (FilterType) {
    FilterType["include"] = "include";
    FilterType["exclude"] = "exclude";
})(FilterType || (exports.FilterType = FilterType = {}));
/**
 * Asserts that exactly one element in the array is defined.
 */
function isExactlyOneDefined(vars) {
    const definedCount = vars.filter((v) => v !== undefined).length;
    return definedCount === 1;
}
